import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import {ISOrigin} from "~/interfaces/salesforceInterfaces";
import ModelMappingOriginSalesforce from "~/models/mapping/modelMappingOriginSalesforce";
import {SalesforceApiDataType} from "~/enums/salesforceApiDataType";
import {DimensionalType} from "~/enums/dimensionalType";
import {sfUploaderOrigin} from "~/models/mapping/salesforceHelpers/fileUploaderHelper";

export default class ModelMappingValueOriginSalesforce extends ModelMappingValueOrigin<ISOrigin, ModelMappingOriginSalesforce> {
  isIndexed: boolean = true

  get origin(): ISOrigin {
    return this.id === sfUploaderOrigin.name ? sfUploaderOrigin : this.modelMappingOrigin.origin?.fields?.find(f => f.name === this.id)
  };

  get value() {
    const label = this.origin === sfUploaderOrigin ? this.origin.label : this.origin.name;
    return {label};
  };

  get valueType(): string {
    return this.origin.type;
  }

  get isUploader(): boolean {
    if (!this.origin) return false;
    return this.origin === sfUploaderOrigin;
  }

  get fileDimensionalType(): DimensionalType {
    if (!this.isUploader) { return null; }

    return DimensionalType.Multi;
  }

  get enumValueType(): SalesforceApiDataType {
    if (this.origin) {
      return SalesforceApiDataType[this.origin.type]
    }
  }

  get isSinglePicklist(): boolean {
    return this.enumValueType === SalesforceApiDataType.picklist;
  }

  get isMultiPicklist(): boolean {
    return this.enumValueType === SalesforceApiDataType.multipicklist;
  }
}